import Vue from 'vue'
import Vuex, {Store} from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import {apiDrupal} from '@/api'

Vue.use(Vuex)

const state = {
    mazlicek: {
        nid: 0,
        step: {
            current: 1,
            max: 9
        },
        jmeno: {
            valid: false,
            value: null
        },
        rasa: {
            typ: 'app_rasa',
            valid: false,
            id: null,
            velikost: null,
            priceRatio: null,
            autocomplete: {
                keyword: ''
            }
        },
        fotografie: {
            typ: '',
            valid: false,
            value: '',
            icnValue: '',
            url: '',
            cropOptions: null,
            original: '',
            imgCropComplete: false,
            timestamp: null
        },
        narozeniny: {
            valid: false,
            value: null,
            vypocetRok: -1,
            vypocetMesic: -1,
            narozeniRok: -1,
            narozeniMesic: -1,
            narozeniDen: -1
        },
        pohlavi: {
            valid: false,
            value: null,
            laktujici: false
        },
        hmotnostkondice: {
            valid: false,
            hmotnost: 0,
            hmotnostJednostka: 'kg',
            kondice: null,
            rebuilded: false
        },
        //NOTE: Aktivita
        pohyb: {
            valid: false,
            id: null
        },
        alergie: {
            valid: false,
            alergie: false,
            alergeny: []
        },
        suroviny: {
            valid: false,
            slozky: {},
        },
        hotovekrmivo: {
            valid: false
        },
        jeStene: false,
        krmivo: {
            nid: 0,
            tydny: {
                value: 4,
                data: {
                    koeficient: "1.20",
                    nazev: "Na 4 týdny",
                    pocetTydnu: "4"
                }
            },
            cena: {
                den: 0,
                celkem: 0,
            },
            extraZabalit: false,
            zkusebni: false,
            feedData: {
                feedRatio: null
                // {
                //     nutritionalRequirements: {
                //         popis_cj_final: ''
                //     },
                //     weightFeedRatio: 0,
                //     originalWeightFeedRatio: 0
                // }
            },
            aditionalServices: [],
            selectedAdditions: []
        },
        productLoaded: {
            value: false
        },
        petLoaded: {
            value: false
        },
        orderData: {
            activeSubscription: false,
            isFirstOrderSent: false,
            orderSendDate: null,
            isFirstOrder: false,
            firstOrderPrice: null
        },
        finalTexts: {},
        grandTexts: [],
        confirmToSave: false,
    },
    loading: false,
}

const mutations = {
    setMazlicek: function (state, mazlicek) {
        Object.assign(state.mazlicek, mazlicek)
    },
    setLoading(state, loading) {
        state.loading = Boolean(loading)
    }
}

const actions = {
    updatePet({commit}, mazlicek) {
        commit("setLoading", true)

        return new Promise((resolve, reject) => {
            // console.log('UPDATE PET: confirm ' + mazlicek.confirmToSave)
            // console.log(mazlicek.hmotnostkondice.hmotnost)
            apiDrupal.post('/set-pet', mazlicek)
                .then((res) => {
                    mazlicek.nid = res.data.data.nid;
                    commit('setMazlicek', mazlicek)
                    commit("setLoading", false)
                    resolve(res);
                })
                .catch((res) => {
                    commit("setLoading", false)

                    if (process.env.NODE_ENV === 'development') {
                        commit('setMazlicek', mazlicek)
                        resolve(res);
                    } else {
                        reject(res)
                    }
                })
        })
    },
    updateProduct({commit}, mazlicek) {
        commit("setLoading", true)

        return new Promise((resolve, reject) => {
            apiDrupal.post('/set-product', mazlicek)
                .then((res) => {
                    mazlicek.krmivo.nid = res.data.data.nid;
                    commit('setMazlicek', mazlicek)
                    commit("setLoading", false)
                    resolve(res);
                })
                .catch((res) => {
                    commit("setLoading", false)

                    if (process.env.NODE_ENV === 'development') {
                        commit('setMazlicek', mazlicek)
                        resolve(res);
                    } else {
                        reject(res)
                    }
                })
        })
    }
}


const store = new Store({
    state,
    mutations,
    actions,
    /*plugins: [
      createPersistedState({
        getState: (key) => Cookies.getJSON(key),
        setState: (key, state) => Cookies.set(key, state, { expires: 1 })
      })
    ]*/
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js